var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowLeftSmallMono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2968 22.6126C17.0974 22.6127 16.8999 22.5734 16.7157 22.497C16.5316 22.4205 16.3643 22.3084 16.2236 22.1671L8.62982 14.5734C8.48874 14.4323 8.37683 14.2649 8.30047 14.0806C8.22411 13.8963 8.18481 13.6988 8.18481 13.4993C8.18481 13.2998 8.22411 13.1022 8.30047 12.918C8.37683 12.7337 8.48874 12.5662 8.62982 12.4252L16.2236 4.83142C16.3635 4.68548 16.5312 4.56895 16.7167 4.48866C16.9023 4.40837 17.102 4.36594 17.3042 4.36385C17.5063 4.36176 17.7069 4.40007 17.8941 4.47651C18.0812 4.55295 18.2513 4.666 18.3942 4.80902C18.5371 4.95204 18.65 5.12216 18.7263 5.3094C18.8026 5.49663 18.8407 5.69721 18.8385 5.89939C18.8362 6.10156 18.7937 6.30124 18.7132 6.48674C18.6328 6.67223 18.5161 6.8398 18.3701 6.97961L11.8513 13.5001L18.3701 20.0189C18.5828 20.2312 18.7277 20.5019 18.7865 20.7966C18.8454 21.0913 18.8154 21.3969 18.7005 21.6746C18.5856 21.9523 18.3909 22.1896 18.141 22.3566C17.8912 22.5236 17.5974 22.6127 17.2968 22.6126Z",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftSmallMono);
export default __webpack_public_path__ + "static/media/icon-arrow-left-small-mono.69da0cb5ab483df43a27d35d1c996cea.svg";
export { ForwardRef as ReactComponent };